/**
 * @generated SignedSource<<fac45d0b5de25565afe3e0cc36fb419b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PinnedEvent$data = {
  readonly actor: {
    readonly " $fragmentSpreads": FragmentRefs<"EventActor" | "EventActorAvatarItemBadge">;
  } | null;
  readonly createdAt: string;
  readonly databaseId: number | null;
  readonly " $fragmentType": "PinnedEvent";
};
export type PinnedEvent$key = {
  readonly " $data"?: PinnedEvent$data;
  readonly " $fragmentSpreads": FragmentRefs<"PinnedEvent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PinnedEvent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventActor"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventActorAvatarItemBadge"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PinnedEvent",
  "abstractKey": null
};

(node as any).hash = "6a703a3e6420fac4080ae415a5988281";

export default node;
